'use client'

import { Button, Image } from '@vinted/web-ui'
import { useState } from 'react'
import Script from 'next/script'

import { useAsset } from '@marketplace-web/shared/assets'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useLocation } from '@marketplace-web/shared/browser'
import { getIsInCatalog } from '@marketplace-web/catalog/catalog-data'

export const HeaderChatkit = () => {
  const [isOpen, setIsOpen] = useState(false)
  const isFsOn = useFeatureSwitch('chatkit_poc_internal')
  const { relativeUrl } = useLocation()
  const asset = useAsset()

  const handleClick = () => {
    window.dispatchEvent(new CustomEvent('ChatKit:toggle'))
    setIsOpen(prev => !prev)
  }

  if (!isFsOn) return null
  if (!getIsInCatalog(relativeUrl)) return null

  return (
    <>
      <Script src="https://cdn.platform.openai.com/deployments/chatkit/7aa9f3c7-33a1-49d7-ac6a-ec08a5092eba/chatkit.js" />
      <Button
        onClick={handleClick}
        icon={
          <Image
            src={asset(`/icons/${isOpen ? 'starmagicon24' : 'starmagicoff24'}.svg`)}
            size="regular"
          />
        }
        styling={Button.Styling.Flat}
      />
    </>
  )
}
